import React from 'react';
import { Tag } from 'antd';
import { TICKET_STATUS_CONFIG } from '../../const/ChatConst';

export const TicketStatus = ({ status, ...props }) => {
  const config = TICKET_STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <Tag {...config} {...props}>
      {config.label}
    </Tag>
  );
};
